import { useState } from "react"
import { Button } from "../components/ui/button"
import { Input } from "../components/ui/input"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table"
import { Search} from "lucide-react"
import useSWR from "swr"
// import useSWRMutation from "swr/dist/mutation"
import axiosConfig, { fetcher } from "../util/axiosConfig"
import {  message, Popconfirm } from "antd"
import PageSpinner from "../components/PageSpinner"
import dayjs from "dayjs"
import AddAdmin from "./AddAdmin"
import requestErrorHandler from "../util/requestErrorHandler"

export default function AdminTable() {
  const [selectedAdmin, setSelectedAdmin] = useState<FederatedAdmin>()
  const [view, setView] = useState<number>(1)
  const { data, isLoading, mutate } = useSWR("/newAdmin/all", fetcher)
  const [isDisabling, setIsDisabling] = useState<boolean>(false);

  const admins: FederatedAdmin[] = data?.admins ?? [];

  const handleSaveZone = async (type: "save" | "update" | "delete", id?: string) => {
    setIsDisabling(true);
    try {
      await axiosConfig.delete(`/newAdmin/delete-admin/${id}`)
      message.success("Admin Deleted successfully");
      mutate();
    } catch (error) {
      requestErrorHandler(error);
    } finally{
      setIsDisabling(false);
    }
  }

  if (isLoading){
    return <PageSpinner/>
  }

  const TableView = () => <div>
    {/* Search and Add Zone */}
    <div className="flex justify-between items-center mb-6">
      <div className="relative w-64">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
        <Input type="text" placeholder="Search" className="pl-10 pr-4 py-2 w-full border rounded-md" />
      </div>
      <Button onClick={() => setView(2)} className="bg-blue-600 hover:bg-blue-700 text-white" >
        Add Admin
      </Button>
    </div>

    {/* Zones Table */}
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="font-semibold">Name</TableHead>
          <TableHead className="font-semibold">Email address</TableHead>
          <TableHead className="font-semibold">Accounts</TableHead>
          <TableHead className="font-semibold">Date added</TableHead>
          <TableHead className="font-semibold text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {admins?.map((zone: FederatedAdmin) => (
          <TableRow key={zone.id} className="border-t">
            <TableCell>{zone.name}</TableCell>
            {/* <TableCell className={zone.type === "Quarry" ? "text-blue-600" : "text-blue-600"}>
            {zone.type}
          </TableCell> */}
            <TableCell>{zone.email}</TableCell>
            <TableCell> {zone.permissions.length < 1 ? "Global":"Federated"} </TableCell>
            <TableCell>{dayjs(zone.updatedAt).format("DD/MM/YYYY")}</TableCell>
            <TableCell className="text-right">
              <div className="flex justify-end space-x-2">
                <Button onClick={() => {
                  // setSelectedZone(zone);
                  setSelectedAdmin(zone);
                  setView(2)
                }} className="bg-blue-600 hover:bg-blue-700 text-white">Edit Access</Button>
                <Popconfirm
                  okText="Yes"
                  cancelText="No"
                  cancelButtonProps={{ type: "primary" }}
                  okButtonProps={{ danger: true, type: "default" }}
                  onConfirm={() => handleSaveZone("delete", zone.id)}
                  title="Are you sure you want to revoke this Admin?"
                >
                  <Button  disabled={isDisabling} className="bg-orange-500 hover:bg-orange-600 text-white">Delete</Button>
                </Popconfirm>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>




  if (isLoading) {
    return <PageSpinner />
  }

  return (
    <>
      {
        view === 1 ?
          <TableView /> :
          <AddAdmin admin={selectedAdmin!} setView={setView} onSave={() => mutate()} />
      }
    </>
  )
}

